module.exports = __webpack_public_path__ + "static/media/device.76d35b11.png";